"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HOUR = exports.HOUR = 60;
var DAY = exports.DAY = HOUR * 24;
var WEEK = exports.WEEK = DAY * 7;

var SUNDAY = exports.SUNDAY = DAY * 0;
var MONDAY = exports.MONDAY = DAY * 1;
var TUESDAY = exports.TUESDAY = DAY * 2;
var WEDNESDAY = exports.WEDNESDAY = DAY * 3;
var THURSDAY = exports.THURSDAY = DAY * 4;
var FRIDAY = exports.FRIDAY = DAY * 5;
var SATURDAY = exports.SATURDAY = DAY * 6;